import Layout from './components/Layout/Layout';
import Home from './Home/Home';
import AOS from 'aos';
import { useEffect } from 'react';
import 'aos/dist/aos.css'
import './styles/common.scss'

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
      mirror: false
    });
  }, [])
  return (
    <>
      <Layout>
        <Home />
      </Layout>
    </>
  );
}

export default App;
